import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=55741cce&scoped=true&"
import script from "./UploadList.vue?vue&type=script&lang=js&"
export * from "./UploadList.vue?vue&type=script&lang=js&"
import style0 from "./UploadList.vue?vue&type=style&index=0&id=55741cce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55741cce",
  null
  
)

export default component.exports